export interface DefaultLevel {
  name: string;
  category: string;
  sort_order: number;
}

export const LEVEL_CATEGORIES = [
  'İlkokul',
  'Ortaokul',
  'Lise',
  'LGS',
  'TYT',
  'AYT',
  'KPSS',
  'AGS',
  'DGS',
  'Birebir Ders',
  'Kamp',
  'Diğer',
] as const;

export const DEFAULT_LEVELS: DefaultLevel[] = [
  { name: '4. Sınıf', category: 'İlkokul', sort_order: 1 },
  { name: '5. Sınıf', category: 'Ortaokul', sort_order: 2 },
  { name: '6. Sınıf', category: 'Ortaokul', sort_order: 3 },
  { name: '7. Sınıf', category: 'Ortaokul', sort_order: 4 },
  { name: '8. Sınıf', category: 'Ortaokul', sort_order: 5 },
  { name: 'LGS Hazırlık', category: 'LGS', sort_order: 6 },
  { name: '9. Sınıf', category: 'Lise', sort_order: 7 },
  { name: '10. Sınıf', category: 'Lise', sort_order: 8 },
  { name: '11. Sınıf', category: 'Lise', sort_order: 9 },
  { name: '12. Sınıf', category: 'Lise', sort_order: 10 },
  { name: 'TYT Matematik', category: 'TYT', sort_order: 11 },
  { name: 'AYT Matematik', category: 'AYT', sort_order: 12 },
  { name: 'KPSS Lisans', category: 'KPSS', sort_order: 13 },
  { name: 'KPSS Önlisans', category: 'KPSS', sort_order: 14 },
  { name: 'KPSS Ortaöğretim', category: 'KPSS', sort_order: 15 },
  { name: 'AGS', category: 'AGS', sort_order: 16 },
  { name: 'DGS', category: 'DGS', sort_order: 17 },
  { name: 'Birebir Ders', category: 'Birebir Ders', sort_order: 18 },
  { name: 'Genel Matematik Kampı', category: 'Kamp', sort_order: 19 },
];

export const DAY_OPTIONS = [
  'Pazartesi',
  'Salı',
  'Çarşamba',
  'Perşembe',
  'Cuma',
  'Cumartesi',
  'Pazar',
  'Haftanın Belirli Günleri',
  'Ders Günleri Daha Sonra Belirlenecek',
] as const;

export const COLOR_OPTIONS = [
  { value: '#6366f1', label: 'Mor' },
  { value: '#0ea5e9', label: 'Mavi' },
  { value: '#10b981', label: 'Yeşil' },
  { value: '#f59e0b', label: 'Turuncu' },
  { value: '#ef4444', label: 'Kırmızı' },
  { value: '#ec4899', label: 'Pembe' },
  { value: '#14b8a6', label: 'Turkuaz' },
  { value: '#8b5cf6', label: 'Lila' },
] as const;